module.exports = __webpack_public_path__ + "img/SH2D_300004.6c98d76e.png";